// File: src/components/opportunity/OpportunityHero.js

import React from 'react';
import styles from './OpportunityHero.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

const HERO_STATS = [
  {
    id: 'waste-market-2034',
    value: '$37.7B',
    label: 'Organic Waste Market by 2034',
    description: 'Growing from $17.61B in 2024 at a 7.91% CAGR.',
  },
  {
    id: 'waste-cagr',
    value: '7.91%',
    label: 'Organic Waste Market CAGR',
    description: 'Driven by landfill bans and circular economy mandates.',
  },
  {
    id: 'fertilizer-market-2034',
    value: '$16.6B',
    label: 'Organic Fertilizer Market by 2034',
    description: 'More than doubling from $7.71B in 2025.',
  },
  {
    id: 'fertilizer-cagr',
    value: '9.02%',
    label: 'Organic Fertilizer Market CAGR',
    description: 'Fuelled by soil health needs and regulatory pressure.',
  },
];

function OpportunityHero() {
  return (
    <section className={styles.section}>
      <div className={styles.bg} aria-hidden="true" />

      <div className={cn('site-container', styles.inner)}>

        {/* Heading block */}
        <ScrollAnimation className={styles.headingBlock}>
          <p className={styles.eyebrow}>The Opportunity</p>
          <h1 className={styles.heading}>
            Two Markets.
            <br />
            <span className={styles.headingAccent}>One Solution.</span>
          </h1>
          <p className={styles.subheading}>
            GreenScience sits at the intersection of two rapidly expanding
            markets — organic waste management and organic fertilizer. While
            others choose one, our process captures both simultaneously,
            creating a uniquely resilient and high-growth business model.
          </p>
        </ScrollAnimation>

        {/* Stat strip — 4 stats, 2×2 on desktop */}
        <div className={styles.statGrid}>
          {HERO_STATS.map((stat, i) => (
            <ScrollAnimation
              key={stat.id}
              delay={i * 100}
              className={styles.statItem}
            >
              <span className={styles.statValue}>{stat.value}</span>
              <span className={styles.statLabel}>{stat.label}</span>
              <span className={styles.statDesc}>{stat.description}</span>
            </ScrollAnimation>
          ))}
        </div>

      </div>
    </section>
  );
}

export default OpportunityHero;